module.exports = __webpack_public_path__ + "static/slide-5-3ff229300469c980c46b15022998436f.svg";